module.exports = __webpack_public_path__ + "img/bank-transfer.d939f835.svg";